<template>
  <v-layout row justify-center>
    <v-dialog v-model="show_modal" scrollable max-width="360px" style="border-radius: 10px" >
      <v-card style="border-radius: 10px">
        <v-card-title
          style="font-size: 18px; font-weight: 500; background: #E2E8EB; color: #5A6B8E"
        >{{title}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;">
          <v-checkbox
            v-model="select_all"
            label="Seleccionar todos"></v-checkbox>
          <v-checkbox
            style="margin-top: 0px"
            color="#1476FB"
            v-for="(trainer, index) in trainers"
            :key="index"
            v-model="selected_trainers"
            :label="trainer.attributes.name"
            :value="trainer"></v-checkbox>
        </v-card-text>
        <v-card-actions justify-end class="trainers__modal--buttons_container">
          <v-btn color="grey lighten-1" flat @click.native="closeModal()">Cerrar</v-btn>
          <v-btn color="#5A6B8E" flat @click.native="saveTrainers()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props:{
    trainers: {
      type: Array,
      default: []
    },
    selected: {
      type:Array
    },
    title: {
      type: String
    }
  },
  data(){
    return{
      show_modal: true,
      selected_trainers: this.selected,
      select_all: false
    }
  },
  methods: {
    closeModal(){
      this.selected_trainers = []
      this.$emit('closeTrainersModal', false)
    },
    saveTrainers(){
      this.$emit('saveTrainers', this.selected_trainers)
    }
  },
  watch:{
    select_all(){
      // cl select all
      this.select_all ? this.selected_trainers = this.trainers : this.selected_trainers = []
      // cl selected_trainers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/TrainersModal.vue